import http, { AUTH_ROUTES } from '../../../services/api';

export const vote = async (setLoading, payload) => {
  try {
    const { data } = await http.put(AUTH_ROUTES.VOTE_AN_OPTION, payload);
    console.log('data', data);
  } catch (e) {
    console.log('e', e.response);
  } finally {
    setLoading(false);
  }
};

export const getPolls = async (setLoading, userId, setPolls) => {
  setLoading(true);
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_POLLS(userId));
    console.log('data', data);
    setPolls(data?.polls);
  } catch (e) {
    console.log('e', e.response);
  } finally {
    setLoading(false);
  }
};
export const getSinglePoll = async (setLoading, userId, pollId, setPoll) => {
  setLoading(true);
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_SINGLE_POLL(userId, pollId));
    console.log('data', data?.polls[0]);
    setPoll(data?.polls[0]);
  } catch (e) {
    console.log('e', e.response);
  } finally {
    setLoading(false);
  }
};
